/**
 * Hero left column — headline, CTAs, trust line, capability tags.
 */
import React from 'react';
import {Link} from "react-router-dom";
import {heroContent, heroCapabilities} from "../data";

export default function HeroContent() {
    const {eyebrow, headline, headlineAccent, description, trustLine, primaryCta, secondaryCta} = heroContent;

    const headlineParts = headline.split(headlineAccent);
    const hasAccent = headlineParts.length > 1;

    return (
        <div className="hx-content">
            <p className="hx-eyebrow hx-enter" style={{'--hx-delay': '0ms'}}>{eyebrow}</p>
            <h1 className="hx-headline hx-enter" style={{'--hx-delay': '80ms'}}>
                {hasAccent ? (
                    <>
                        {headlineParts[0]}
                        <span className="wx-grad-text">{headlineAccent}</span>
                        {headlineParts[1]}
                    </>
                ) : (
                    headline
                )}
            </h1>
            <p className="hx-description hx-enter" style={{'--hx-delay': '160ms'}}>
                {description}
            </p>
            <div className="hx-cta-group hx-enter" style={{'--hx-delay': '240ms'}}>
                <Link to="/contact" className="wx-btn wx-btn-primary hx-cta-primary">
                    {primaryCta}
                    <span className="hx-cta-arrow" aria-hidden="true">→</span>
                </Link>
                <Link to="/products" className="wx-btn wx-btn-ghost hx-cta-secondary">
                    {secondaryCta}
                </Link>
            </div>
            <p className="hx-trust hx-enter" style={{'--hx-delay': '320ms'}}>{trustLine}</p>
            <ul className="hx-capabilities hx-enter" style={{'--hx-delay': '400ms'}} aria-label="Capabilities">
                {heroCapabilities.map((cap, i) => (
                    <li key={cap} className="hx-cap-tag" style={{'--hx-tag-delay': `${i * 60}ms`}}>
                        {cap}
                    </li>
                ))}
            </ul>
        </div>
    );
}
